/**
 * Intent vocabulary labels — the ONLY place the goal / channel / product-analytics
 * enums are turned into English UI copy (AM-4/AM-14). The header goal line
 * (`ActivationChecklist`) and the in-place intent popover (`IntentPopover`) both
 * read from here, so the two can never drift.
 *
 * `GOAL_LABELS` are lower-case because the header renders them mid-sentence
 * ("Goal: validate an idea"); standalone controls capitalise via `capitalize()`.
 */
import type { IntentChannel, IntentGoal, IntentProductAnalytics } from '@modules/shared-types';

export const GOAL_LABELS: Record<IntentGoal, string> = {
  first_value: 'validate an idea',
  sell: 'sell',
};

export const CHANNEL_LABELS: Record<IntentChannel, string> = {
  facebook: 'Facebook',
  tiktok: 'TikTok',
  google_ads: 'Google Ads',
  organic: 'Organic',
};

export const PRODUCT_ANALYTICS_LABELS: Record<IntentProductAnalytics, string> = {
  ga4: 'GA4',
  mixpanel: 'Mixpanel',
  amplitude: 'Amplitude',
  posthog: 'PostHog',
};

export const INTENT_POPOVER_COPY = {
  goalLabel: 'Goal',
  channelsLabel: 'Ad channels',
  productAnalyticsLabel: 'Product analytics',
  apply: 'Apply',
  questionnaire: 'Open the questionnaire instead',
} as const;

export const capitalize = (value: string): string => value.charAt(0).toUpperCase() + value.slice(1);
